import { useLazyFetchDriversQuery } from '@api/Trinium/Endpoints/Driver/slice';
import useCurrentTerminal from '@hooks/useCurrentTerminal';
import useDebouncer from '@hooks/useDebounce';
import { useMemo, useState } from 'react';
import LookupList from './LookupList';
import { LookupProps, minimumSearchLength } from './types';

export default function DriverLookup(props: LookupProps) {
  const { number: terminalNumber } = useCurrentTerminal();
  const [fetchDrivers, { data, isFetching }] = useLazyFetchDriversQuery();
  const [search, setSearch] = useState('');

  useDebouncer(
    () => {
      // Unrestricted by active status: a driver who has since been deactivated can still hold legs on the board,
      // and a query that cannot name them would be unbuildable
      if (search.length >= minimumSearchLength) void fetchDrivers({ terminalNumber, startsWith: search });
    },
    [search, terminalNumber],
    500
  );

  const items = useMemo(
    () =>
      (data ?? []).map((driver) => ({
        id: driver.id,
        name: driver.name,
        detail: driver.tractorId ? `Truck ${driver.tractorId}` : undefined
      })),
    [data]
  );

  return (
    <LookupList
      {...props}
      items={items}
      isLoading={isFetching}
      onSearch={setSearch}
    />
  );
}
